<template>
  <div class="c-image">
    <div class="c-thumb">
      <div class="c-thumb-wrapper" :class="{ 'm-default-bg': !image }">
        <Spin v-show="loading" fix>
          <Icon type="ios-loading" size="30" class="c-fix-loading" />
          <span>上传中...</span>
        </Spin>
        <div class="c-alt-upload" :class="{ 'c-hide-upload': Boolean(image) }">
          <div class="c-upload-btns">
            <Button type="primary" @click="$emit('on-select', { name, width, height, size, type })">{{ btnText }}</Button>
            <Upload action="" :before-upload="preUpload">
              <Button>本地上传</Button>
            </Upload>
          </div>
          <div class="c-upload-txt">
            <span>{{ description }}规格：{{ width }}x{{ height }}</span>
            <span>{{ description }}大小：{{ size | smartSize }}</span>
            <span>支持类型：{{ format | formatType }}</span>
          </div>
        </div>
        <!-- 图片地址 -->
        <img v-if="image" :src="image" :class="{ 'm-vertical-img': vertical }" :style="setWrapperWidth" alt="" />
      </div>
    </div>
    <div class="c-col-msg" v-if="msg">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import mixins from './mixins'
import mixinVerify from './mixin-verify'
import { isArray } from '@/common/js/utils'
import { uploadLocalImage } from '@/api/baidu.model'
export default {
  name: 'cImage',
  mixins: [mixins, mixinVerify],
  props: {
    value: {
      type: [String, Number]
    },
    name: {
      type: String
    },
    type: {
      type: String
    },
    description: {
      type: String
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    size: {
      type: Number
    },
    format: {
      type: Array,
      default() {
        return ['jpeg', 'png']
      }
    },
    required: {
      type: Boolean
    },
    verify: {
      type: Boolean
    }
  },
  computed: {
    image: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    vertical() {
      return this.height >= this.width
    },
    setWrapperWidth() {
      const width = (148 * this.width) / this.height
      return { width: `${parseInt(width)}px` }
    },
    btnText() {
      return this.image ? `更新${this.description}` : `选择${this.description}`
    }
  },
  methods: {
    uploadFile(file) {
      const params = {
        account: this.$store.state.Baidu.account,
        width: this.width,
        height: this.height,
        file
      }

      this.loading = true
      uploadLocalImage(params).then((data) => {
        this.loading = false
        data = isArray(data) && data.pop()
        if (data) this.$emit('on-upload', { type: this.type, name: this.name, size: this.size, data })
      })
    }
  },
  data() {
    return {
      loading: null
    }
  },
  watch: {
    value(nVal) {
      this.$emit('on-change', nVal)
    }
  }
}
</script>
<style lang='scss' scoped>
.c-image {
  position: relative;
  z-index: 998;
  height: 148px;
  min-width: 260px;

  .c-thumb {
    width: inherit;
    height: inherit;

    .m-default-bg {
      height: inherit;
      background-color: #e8e8e8;
    }

    .c-thumb-wrapper {
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 9;

      img {
        width: 100%;
        height: 100%;
        display: block;

        &.m-vertical-img {
          margin: 0 auto;
        }
      }
    }

    .c-alt-upload {
      width: 100%;
      height: 100%;
      padding: 0 12px;
      position: absolute;
      z-index: 7;
      top: 0;
      left: 0;
      text-align: center;

      .c-upload-btns {
        padding: 22px 0px 12px;
        display: flex;
        justify-content: center;
      }

      .c-upload-txt {
        padding: 6px 12px;

        span {
          display: block;
          line-height: 1.4;
        }
      }
    }

    .c-hide-upload {
      opacity: 0;

      &:hover {
        opacity: 1;
        background-color: rgba(0, 0, 0, 0.6);

        .c-upload-txt {
          color: #fff;
        }
      }
    }
  }

  .c-col-msg {
    position: absolute;
    z-index: 997;
    left: 0;
    bottom: -16px;
    color: #ff4400;
  }

  .c-fix-loading {
    animation: ani-demo-spin 1s linear infinite;
  }
}
</style>
